import React, { useRef, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle as faPlaySolid } from "@fortawesome/free-solid-svg-icons";
import { faPauseCircle as faPauseRegular } from "@fortawesome/free-regular-svg-icons";
import { faPlayCircle as faPlayRegular } from "@fortawesome/free-regular-svg-icons";
import { faPauseCircle as faPauseSolid } from "@fortawesome/free-solid-svg-icons";

export default function Footer() {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true); // start playing

  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const pauseAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  // Autoplay on mount
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.play().catch(() => console.log("Autoplay blocked"));
      setIsPlaying(true);
    }
  }, []);

  return (
    <footer className="grid grid-cols-4 text-center text-xs py-4 px-4">
      <div>
        <p>Playing In Store:</p>
        <p>Aphex Twin - Track 19</p>

        {/* Play/Pause buttons */}
        <div className="flex justify-center items-center gap-0 mt-1">
          <button
            type="button"
            onClick={playAudio}
            className="bg-white p-0 text-gray-600"
          >
            <FontAwesomeIcon
              icon={isPlaying ? faPlaySolid : faPlayRegular}
              size="1x"
            />
          </button>
          <button
            type="button"
            onClick={pauseAudio}
            className="bg-white p-0 text-gray-600"
          >
            <FontAwesomeIcon
              icon={isPlaying ? faPauseRegular : faPauseSolid}
              size="1x"
            />
          </button>
        </div>

        {/* Audio element */}
        <audio ref={audioRef} loop>
          <source src="/audio/stone_in_focus.mp3" type="audio/mp3" />
          Your browser does not support the audio element.
        </audio>
      </div>

      <div>
        <img
          src="/images/viiv-logo.png"
          alt="VIIIV Logo"
          className="mx-auto h-4"
        />
      </div>

      <div>
        <a
          href="https://www.instagram.com/oamc_official/?hl=en"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-600"
        >
          Instagram
        </a>
      </div>

      <div className="flex justify-center items-start -mt-1 px-4">
        <div className="flex gap-2 max-w-xs w-full items-center">
          <input
            type="email"
            placeholder="Enter Email"
            className="px-2 py-1 text-xs flex-1 bg-transparent focus:outline-none"
            style={{
              fontFamily: '"Avenir Next W01", sans-serif',
              fontSize: "10px",
              color: "#666666",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          />
          <button
            className="px-4 py-1 text-xs bg-transparent hover:bg-gray-200 transition-colors duration-200"
            style={{
              fontFamily: '"Avenir Next W01", sans-serif',
              fontSize: "10px",
              color: "#666666",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Contact
          </button>
        </div>
      </div>
    </footer>
  );
}
